type Rgb = [number, number, number];

const DARK_FOREGROUND = '9 9 11';
const LIGHT_FOREGROUND = '255 255 255';

const parseHexColor = (color: string): Rgb | null => {
    const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color.trim());
    if (!match) {
        return null;
    }

    return [
        Number.parseInt(match[1], 16),
        Number.parseInt(match[2], 16),
        Number.parseInt(match[3], 16),
    ];
};

const parseRgbChannels = (color: string): Rgb | null => {
    const channels = color.trim().split(/\s+/).map((channel) => Number(channel));
    if (channels.length !== 3 || channels.some((channel) => !Number.isInteger(channel) || channel < 0 || channel > 255)) {
        return null;
    }

    return channels as Rgb;
};

const parseColor = (color: string): Rgb | null => (
    color.trim().startsWith('#') ? parseHexColor(color) : parseRgbChannels(color)
);

const linearize = (channel: number) => {
    const normalized = channel / 255;
    return normalized <= 0.04045 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
};

export function getAccentForegroundColor(color: string): typeof DARK_FOREGROUND | typeof LIGHT_FOREGROUND {
    const rgb = parseColor(color);
    if (!rgb) {
        return LIGHT_FOREGROUND;
    }

    const [red, green, blue] = rgb;
    const luminance = 0.2126 * linearize(red) + 0.7152 * linearize(green) + 0.0722 * linearize(blue);

    return luminance > 0.179 ? DARK_FOREGROUND : LIGHT_FOREGROUND;
}
